// Глобальная настройка axios: базовый адрес API и проброс JWT в каждый запрос.
// Сервисы продолжают использовать глобальный axios — отдельный инстанс не нужен.
import axios from 'axios'
import { getToken, clearToken, login } from '@/auth/auth'

// Базовый адрес API. На сборку задаётся VUE_APP_API_URL
// (напр. https://postcalc-api.s25.work). Весь API под /api, поэтому пути в
// сервисах начинаются с /v1/... (публичный) или /admin/... (админский).
const API_URL: string = process.env.VUE_APP_API_URL || ''

export function setupHttp(): void {
  axios.defaults.baseURL = `${API_URL}/api`

  axios.interceptors.request.use(config => {
    const token = getToken()

    if (token) {
      config.headers = config.headers || {}
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  })

  // Протух/невалиден токен → чистим и уводим на SSO за новым.
  // В dev (VUE_APP_AUTH_SERVICE не задан) — не редиректим: бэк сам отдаёт dev-юзера.
  axios.interceptors.response.use(
    response => response,
    error => {
      if (
        error.response &&
        error.response.status === 401 &&
        process.env.VUE_APP_AUTH_SERVICE
      ) {
        clearToken()
        login()
      }

      return Promise.reject(error)
    }
  )
}
